import React, { Component } from 'react';
import { message, Tooltip } from 'antd';
import { connect } from 'dva';
import moment from 'moment';
// eslint-disable-next-line import/no-extraneous-dependencies
import router from "umi/router";
import Container from "../../../../components/Container";
import ListPage from '../../../../components/ListPage';
import ListSearch from '../Components/ListSearch';
import styles from './index.less';
import OperateDropdown from '../../../../components/OperateDropdown';
import { getComposeUrl } from "../../../../utils/common";

const { ListTable } = ListPage;

@connect(({ mySalary, user }) => {
  return {
    ...mySalary,
    currentUser: user.currentUser,
  };
})
class List extends Component {
  componentDidMount() {
    this.handleQuery({
      page: 1,
      pageSize: 10,
      queries: {
        title: '',
        readState: '',
      },
    }
    );

  }

  componentWillUnmount() {
    const { dispatch } = this.props;

    dispatch({
      type: 'mySalary/reset',
    });
  }


  handleError = err => {
    message.error(err);
  };

  handleGoToDetail = (_, data) => {
    const { salarySheetId } = data;
    router.push(getComposeUrl(`/wages/mySalary/detail?id=${salarySheetId}`));
  };

  // 分页器点击
  handlePaginationChange = (page, pageSize) => {

    console.log('handlePaginationChange', pageSize)
    const { queries } = this.props;
    this.handleQuery({
      page,
      pageSize,
      queries,
    }
    )
  };

  // 查询列表数据
  handleQuery = ({ queries = {}, page = 1, pageSize = 10 }) => {
    const { dispatch } = this.props;

    dispatch({
      type: 'mySalary/save',
      payload: {
        queries,
      },
    });

    dispatch({
      type: 'mySalary/fetchSearch',
      payload: {
        page,
        pageSize,
        ...queries,
      },
    });
  };

  handleError = err => {
    message.error(err);
  };


  render() {
    const { pageInfo, list, spinProps, currentUser } = this.props;
    const columns = [
      {
        title: '阅读状态',
        key: 'readStatus',
        dataIndex: 'readStatus',
        // width: 100,
        render: (text, record) => (
          <div className={`read-state ${text === 1 ? 'read' : 'un-read'}`}>
            {text === 1 ? '已阅' : '未阅'}
          </div>
        ),
      },
      {
        title: '标题',
        dataIndex: 'title',
        key: 'title',
        width: 200,
        render: title => (
          <Tooltip placement="top" title={title}>
            <div className="title">{title}</div>
          </Tooltip>
        ),
      },
      {
        title: '发放月份',
        dataIndex: 'salaryMonth',
        key: 'salaryMonth',
        // width: 100,
        render: salaryMonth => salaryMonth || '-'
      },
      {
        title: '发布者',
        dataIndex: 'senderName',
        key: 'senderName',
        render: text => {
          if (!text) {
            return '-';
          }
          if (text.length <= 8) {
            return <span>{text}</span>;
          }
          return (
            <Tooltip placement="top" title={text}>
              <span>{text.substring(0, 8)}...</span>
            </Tooltip>
          );
        },
      },
      {
        title: '接收时间',
        dataIndex: 'receive',
        key: 'receive',
        render: receive => {
          if (!receive) {
            return '-';
          }
          return moment(receive).format('YYYY.MM.DD HH:mm')
        }
      },
    ];

    const pageProps = {
      spinProps,
      className: styles.root,
    };

    const searchProps = {
      type: 'mySalary',
      statusList: [{ readState: '1', name: '已阅' }, { readState: '0', name: '未阅' }],
      handleQuery: this.handleQuery,
    };

    const tableProps = {
      pageInfo,
      columns,
      list,
      rowKey: 'salarySheetId',
      onItemClick: this.handleGoToDetail,
      onPageChange: this.handlePaginationChange,
    };

    return (
      <Container breStates isSplitBar>
        <ListPage {...pageProps}>
          <ListSearch {...searchProps} />
          <div className='divider' />
          <ListTable {...tableProps} />
        </ListPage>
      </Container>
    );
  }
}

export default List;
